import * as React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import Description from "report/common/Description";
const Container = styled.div`
  padding-top: 30%;
  min-height: 600px;
`;
const Headline = styled.h1(
  ({ theme }) => css`
    color: black !important;
    font-size: 2em;
    text-align: center;
    margin-bottom: ${theme.spacings.lg};
  `
);
const Subheadline = styled.h2(
  ({ theme }) => css`
    color: #555 !important;
    font-size: 1.6em;
    text-align: center;
    margin-bottom: ${theme.spacings.lg};
  `
);
const Tz = styled.div(
  ({ theme }) => css`
    text-align: center;
    color: ${theme.colors.text.secondary} !important;
  `
);
const CoverPage = ({ title, description, subtitle, tz }) => {
  const { t } = useTranslation("enterprise_report");
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Headline, null, title), /* @__PURE__ */ React.createElement(Subheadline, null, subtitle), /* @__PURE__ */ React.createElement(Tz, { className: "text-center" }, t("cover_page.timezone", { tz })), description && /* @__PURE__ */ React.createElement(Description, null, description));
};
export default CoverPage;
